<template>
  <div class="block-information localBlock clearfix" v-loading="loading">
    <div class="fr">
      <img src="@/../public/static/img/blockView/java2.png">
    </div>
    <div class="fl">
      <span class="angle"></span>
      <section class="section1">
        <div class="clearfix" id="Block">
          <div class="fl tit">
            <span>{{$t('LocalBlockMsg')}}</span>
            <br class="br"/>
            <img 
              class="app_logo" 
              :src="
              app_logo ? app_logo : 
              app_type == 33 ? './img/blockView/icon/coin.svg' :
              app_type == 17 ? './img/blockView/icon/token.svg' : 
              './img/blockView/icon/default.svg'" > 
            <span class="app_name" v-text="app_name"></span>
          </div>
          <div class="fr">
            <router-link v-if="down!=0" :to="`/LocalblockView/${ $route.params.hid }/${ $route.params.chainNum }/${down}`" class="a" id="prev" v-text="`<${$t('Next')}`">&lt;后一个</router-link>
            <a v-else href="javascript:;" class="a disable" v-text="`<${$t('Next')}`">&lt;后一个</a>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <router-link :to="`/LocalblockView/${ $route.params.hid }/${ $route.params.chainNum }/${up}`" v-if="up!=0" class="a" id="next" v-text="`${$t('Previous')}>`">前一个&gt;</router-link>
            <a v-else href="javascript:;" class="disable a" v-text="`${$t('Previous')}>`">前一个&gt;</a>
          </div>
          <!-- <div class="help fr" @click="helpBol = true">
            <img src="@/../public/static/img/blockView/help.png" alt="">
          </div> -->
        </div>

        <div class="clearfix">
          <div class="row clearfix" id="LocalBlock">
            <span class="key" v-text="`${$t('LocalBlock')}:`">子链区块号:</span>
            <span class="cont" v-text="localblock">
              0
            </span>
          </div>
          <div class="row clearfix" id="BlockHash">
            <span class="key" v-text="`${$t('BlockHash')}:`">块哈希:</span>
            <span class="cont" v-text="block_hash">
              000000000000000000000000000000000000000000000000000000000000000
            </span>
          </div>
          <div class="row clearfix" id="PreviousLocalBlock">
            <span class="key" v-text="`${$t('PreviousLocalBlock')}:`"> 前驱区块号:</span>
            <span class="cont" v-text="previous_local_block">
              0
            </span>
          </div>
          <div class="row clearfix" id="PreviousLocalBlockHash">
            <span class="key" v-text="`${$t('PreviousLocalBlockHash')}:`">前驱区块号哈希:</span>
            <span class="cont" v-text="previous_local_block_hash">
              0000000000000000000000000000000000000000000000000000000000000000
            </span>
          </div>
          <div class="row clearfix" id="BlockSize">
            <span class="key" v-text="`${$t('BlockSize')}:`">块大小:</span>
            <span class="cont" v-text="block_size">
              0KB
            </span>
          </div>
          <div class="row clearfix" id="Difficulty">
            <span class="key" v-text="`${$t('Difficulty')}:`">难度:</span>
            <span class="cont" v-text="difficulty">
              0
            </span>
          </div>
          <div class="row clearfix" id="BlockVersion">
            <span class="key" v-text="`${$t('BlockVersion')}:`">块版本:</span>
            <span class="cont" v-text="block_version">
              0.0.0
            </span>
          </div>
          <div class="row clearfix" id="Time">
            <span class="key" v-text="`${$t('Time')}:`">时间戳:</span>
            <span class="cont" v-text="$retTime(time*1000)">
              0000-00-00
            </span>
          </div>
          <div class="row clearfix" id="Localchain">
            <span class="key" v-text="`${$t('Localchain')}:`">子链号:</span>
            <router-link :to="`/LocalchainView/${$route.params.hid}/${localchain}`" class="cont" v-text="`${$route.params.hid},${localchain}`">
            </router-link>
          </div>
          <div class="row clearfix" id="Hyperblock">
            <span class="key" v-text="`${$t('HyperBlock')}:`">超块号:</span>
            <router-link :to="`/HyperblockView/${$route.params.hid}`" class="cont" v-text="$route.params.hid" >
              000000
            </router-link>
          </div>
          <div class="row clearfix" id="HyperblockHash">
            <span class="key" v-text="`${$t('PreviousHyperBlock_hash')}:`">超块哈希:</span>
            <span class="cont" v-text="hyper_hash">
                0000000000000000000000000000000000000000000000000000000000000000
            </span>
          </div>
        </div>
        <div class="dottedBottom"></div>
        <div class="tit clearfix">
          <div class="fl">
            {{$t('Payload')}}
          </div>
          <div class="fr" style="margin-top: 4px;font-size: 14px;">
            {{$t('AppType')}}: <span class="c_6900B7">{{
              app_type == 33 ? $t('T_coin') :
              app_type == 17 ? $t('T_token') :
              $t('T_default')
            }}</span>
          </div>
        </div>
        <!-- <div class="clearfix" id="Block">
          <img src="@/../public/static/img/blockView/icon-payload.png" style="margin-right: 20px;" class="fl">
          {{$t('Payload')}}
        </div> -->
        <div id="payload">
          <div class="payload_tab">
            <span @click="isPayloadType = 1" :class="[isPayloadType === 1 ? 'active_payload' : '']">
              {{$t('PayloadRaw')}}
            </span>
            <b></b>
            <span @click="isPayloadType = 2" :class="[isPayloadType === 2 ? 'active_payload' : '']">
              {{$t('PayloadParsed')}}
            </span>
          </div>
          <div :class="['cont',{'active': payloadShow}]">
            <span>
              <span ref="spase" >
                {{ 
                  isPayloadType == 1 ? payload_raw :
                  isPayloadType == 2&&payload!=''&&payload!=null&&payload!=undefined  ? payload : 
                  $t('P_default')
                }}
              </span>
              <!-- <span v-show="isPayloadType === 2" ref="spase1" v-text="payload"></span> -->
            </span>
            <div v-show="moreBtn" class="dottedBottom"></div>
            <img v-show="moreBtn" src="@/../public/static/img/home/down.png" @click="payloadShow = !payloadShow" >
          </div>
        </div>
        <div class="row clearfix" id="PayloadHash">
          <span class="key fl" v-text="`${$t('PayloadHash')}:`">负载哈希:</span>
          <span class="cont fl payload_hash" style="margin-right:0px;" v-text="payload_hash">
            0000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000
          </span>
        </div>
        <div class="row" id="PayloadSize">
          <span class="key" v-text="`${$t('PayloadSize')}:`">负载大小:</span>
          <span class="cont" v-text="payload_size">
            0B
          </span>
        </div>
        <div v-if="tx.length > 0" v-show="isPayloadType == 2" class="tx" id="tx">
          <div class="dottedBottom"></div>
          <div class="clearfix">
            <div class="fl tit" v-text="`${$t('tx')}`">
              交易信息
            </div>
          </div>
          <!-- v-text="`${$t('PayloadHash')}:`" -->
          <div  :class="['tx_box',{'active': $route.query.hash == v.hash&&bodyClick}]" v-for="(v,i) in tx" :key="i">
            <div class="head clearfix">
              <span class="fl tx_hash"  v-html="`${v.hash} `">
                交易哈希
              </span>
              <span class="fr tx_time" v-html="`<strong>${$retTime(v.time*1000)}</strong>`">
                交易时间
              </span>
            </div>
            <!-- type 0：挖矿  1：转账 -->
            <div class="cont" v-if="v.type == 1">
              <div class="tx_in">
                <div class="clearfix"  v-for="(v_in,vi) in v.tx_in" :key="vi">
                  <router-link 
                  :to="`/LocalBlockView/${v_in.hid}/${v_in.chain_num}/${v_in.block_id}?hash=${v_in.hash}`" 
                  class="fl address" 
                  v-html="v_in.address"></router-link>
                  
                  <span class="fr value" v-html="`-${(v_in.value/100000000).toFixed(8)}`">

                  </span>
                </div>
              </div>
              <div class="tx_imgBg">
                <div class="img">
                  <svg id="icon-arrow-gray" viewBox="0 0 1024 1024">
                    <path d="M153.996387 878.129548c193.502968 193.469935 507.276387 193.469935 700.779355 0 193.469935-193.469935 193.469935-507.276387 0-700.746322-193.502968-193.502968-507.276387-193.502968-700.779355 0-193.469935 193.469935-193.469935 507.276387 0 700.746322z" fill="#DDDDDD"></path>
                    <path d="M649.744516 512.264258H295.969032v64.016516h353.775484l-133.780645 128.165161h94.604387l167.275355-160.206451-167.275355-160.140387H515.963871z" fill="#FFFFFF"></path>
                  </svg>
                </div>
              </div>
              <div class="tx_out">
                <div class="clearfix" v-for="(v_out,vi) in v.tx_out" :key="vi">
                  <span class="fl address" v-html="v_out.address"></span>
                  <span class="fr value" v-html="`+${(v_out.value/100000000).toFixed(8)}`"></span>
                </div>
              </div>
            </div>
            <div class="cont" v-else-if="v.type == 0">
              <div class="tx_in">
                <span class="coinbase">Coinbase</span>
              </div>
              <div class="tx_imgBg">
                <div class="img">
                  <svg id="icon-arrow-gray" viewBox="0 0 1024 1024">
                    <path d="M153.996387 878.129548c193.502968 193.469935 507.276387 193.469935 700.779355 0 193.469935-193.469935 193.469935-507.276387 0-700.746322-193.502968-193.502968-507.276387-193.502968-700.779355 0-193.469935 193.469935-193.469935 507.276387 0 700.746322z" fill="#DDDDDD"></path>
                    <path d="M649.744516 512.264258H295.969032v64.016516h353.775484l-133.780645 128.165161h94.604387l167.275355-160.206451-167.275355-160.140387H515.963871z" fill="#FFFFFF"></path>
                  </svg>
                </div>
              </div>
              <div class="tx_out">
                <div class="clearfix" v-for="(v_out,vi) in v.tx_out" :key="vi">
                  <span class="fl address" v-html="v_out.address"></span>
                  <span class="fr value" v-html="`+${(v_out.value/100000000).toFixed(8)}`"></span>
                </div>
              </div>
            </div>
            <div class="bottom clearfix">
              <span class="fr" v-html="(v.total_sum/100000000).toFixed(8)"></span>
            </div>
          </div>
          <pages
            v-if="pageCount > 1"
            toLink="LocalBlockView" 
            :pageCount="pageCount" 
            :hid="$route.params.hid"
            :chainNum="$route.params.chainNum"
            :id="$route.params.id"
            :page="page">
          </pages>
        </div>
      </section>
    </div>
    <!-- <help v-show="helpBol" @close="close" /> -->
  </div>
</template>
<script>
import help from '@/components/help.vue'
import pages from '@/components/pages.vue'
export default {
  data() {
    return {
      localblock: 0,
      block_hash: 0,
      previous_local_block: 0,
      previous_local_block_hash: 0,
      block_size: 0,
      difficulty: 0,
      block_version: 0,
      time: 0,
      localchain: 0,
      hyper_hash: 0,
      payload: 0,
      payload_hash: 0,
      payload_size: 0,
      up: 0,
      down: 0,
      helpBol: false,
      payloadShow: false,
      moreBtn: false,
      bodyClick: 1,
      tx: [],
      isPayloadType: 1,
      payload_raw: 0,
      app_type: '',
      app_name: '',
      app_logo: '',
      pageCount: 0,
      page: 0,
      loading: true,
    }
  },
  components:{
    help, pages
  },
  created(){
    var _self = this;
    _self.init();
    document.body.onclick = function(){
      _self.bodyClick = 0;
    }
  },
  watch: {
    $route(){
      let _self = this;
      _self.init();
      setTimeout(function(){
        _self.bodyClick = 1;
      },1)
    },
    payload(){
      this.$nextTick(()=>{
        if(this.$refs.spase.offsetHeight > 270){
          this.moreBtn = true;
        }else{
          this.moreBtn = false;
        }
      })
    },
    isPayloadType(){
      this.$nextTick(()=>{
        if(this.$refs.spase.offsetHeight > 270){
          this.moreBtn = true;
        }else{
          this.moreBtn = false;
        }
      })
    }
  },
  methods: {
    init(){
      this.localblockInfo();
    },
    txInfo(page){
      this.$http({
        url:`hyperchain/tx?hid=${ this.$route.params.hid }&chain_num=${ this.$route.params.chainNum }&id=${ this.$route.params.id }&page=${page}&per_page=10`,
        baseURL: process.env.VUE_APP_CURRENTMODE,
        method: 'get',
      }).then((res)=>{
        var data = res.data;
        console.log('tx:', data);
        if(data.ret == 200){
          this.tx = data.data.data ? data.data.data : [];
          this.pageCount = data.data.pages.page_count;
          if(data.data.pages.page<1){
            this.page = 1;
          }else{
            this.page = data.data.pages.page;
          }
        }
      });
    },
    localblockInfo (){
      this.$http({
        url:`hyperchain/localblock?hid=${ this.$route.params.hid }&chain_num=${ this.$route.params.chainNum }&id=${ this.$route.params.id }`,
        baseURL: process.env.VUE_APP_CURRENTMODE,
        method: 'get',
      }).then((res)=>{
        var data = res.data;
        if(data.ret == 200){
          this.localblock = data.data.localblock;
          this.block_hash = data.data.block_hash;
          this.previous_local_block = data.data.previous_local_block;
          this.previous_local_block_hash = data.data.previous_local_block_hash;
          this.block_size = data.data.block_size;
          this.difficulty = data.data.difficulty;
          this.block_version = data.data.block_version == ""? '0.0.0' : data.data.block_version;
          this.time = data.data.time;
          this.localchain = data.data.localchain;
          this.hyper_hash = data.data.hyper_hash;
          this.payload = data.data.payload;
          this.payload_hash = data.data.payload_hash;
          this.payload_size = data.data.payload_size;
          this.up = data.data.up;
          this.down = data.data.down;

          /*  app_type： 
          **  33  货币类型   coin
          **  17  通证类型   token
          **  0   通用类型   default 
          */  
          this.app_type = data.data.app_type;
          if(this.app_type == 33){
            this.txInfo(this.$route.params.page);
          }else{
            this.tx = [];
          }
          this.app_name = data.data.app_name;
          this.app_logo = data.data.app_logo;
          this.payload_raw = data.data.payload_raw;
          this.loading = false;
        }
      })
    },
    close(){
      this.helpBol = false;
    }
  }
}
</script>

<style lang="scss">
  .payload_tab {
    b {
      display: inline-block;
      margin: 0 10px;
      width: 1px;
      height: 10px;
      background-color: #ddd;
    }

    span {
      position: relative;
      display: inline-block;
      cursor: pointer;
      &:hover{
        color: #e37200;
      }

      &.active_payload {
        color: #e37200;
      }
    }
  }
</style>
